(function () {
  'use strict';

  // 郵便番号→都道府県/市区町村の自動入力（zipcloud API）。
  // account.php / register.php / addresses.php / estimate-address.js（お届け先フォーム）で共通利用。
  // 取得処理は window.SignPrintPostal.lookup(郵便番号) として共用する（管理画面の案件登録が、
  // 7桁入れた時点で自動で調べるのに使う。作業キュー#37）。サイトの「住所検索」ボタンの動きは変えていない。
  var SELECTOR = '.mp-postal-search, .auth-postal-search, .lp-estimate__postal-search';

  // 結果：{ found: true, pref, city } ／ { found: false }（見つからない）。通信の失敗は reject
  function lookup(zip) {
    return fetch('https://zipcloud.ibsnet.co.jp/api/search?zipcode=' + zip)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.status === 200 && data.results && data.results.length > 0) {
          var r = data.results[0];
          return { found: true, pref: r.address1, city: r.address2 + r.address3 };
        }
        return { found: false };
      });
  }
  window.SignPrintPostal = { lookup: lookup };

  document.querySelectorAll(SELECTOR).forEach(function (btn) {
    btn.addEventListener('click', function () {
      var postalEl = document.getElementById(btn.dataset.postalTarget);
      var prefEl   = document.getElementById(btn.dataset.prefTarget);
      var cityEl   = document.getElementById(btn.dataset.cityTarget);
      if (!postalEl) return;
      var zip = postalEl.value.replace(/[^0-9]/g, '');
      if (zip.length !== 7) {
        alert('郵便番号は7桁の数字で入力してください。');
        return;
      }
      var originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = '検索中...';
      lookup(zip)
        .then(function (r) {
          if (r.found) {
            if (prefEl) prefEl.value = r.pref;
            if (cityEl) cityEl.value = r.city;
          } else {
            alert('該当する住所が見つかりませんでした。都道府県・市区町村を手入力してください。');
          }
        })
        .catch(function () {
          alert('住所の自動取得に失敗しました。都道府県・市区町村を手入力してください。');
        })
        .finally(function () {
          btn.disabled = false;
          btn.textContent = originalText;
        });
    });
  });
})();
